export default __webpack_public_path__ + "static/media/ReportIcon-Spine-MS.c0856c70.jpg";